/*
  Brand-scoped search (brand separation Part 1, Task 7).

  The scope string is rendered on <html data-search-scope> (from
  snippets/brand-context.liquid, field 'search_scope') and appended here.
  Leaf Lab-brand pages: `vendor:"Leaf Lab"` -- the marker that makes the results
  page (and predictive-search fragment) Leaf Lab-brand. Nerada pages: EMPTY, so
  nothing is appended -- Shopify search ORs field terms, and `-vendor:"Leaf Lab"`
  made every Nerada search return the whole catalogue (tested 12 Oct 2026).
  The token is appended:
  - on submit of any search form (a hidden `q` carries the scoped query, so the
    visible field never shows the filter);
  - by assets/predictive-search.js via window.withBrandSearchScope().
  Results templates strip the scope back out of the displayed terms. Direct
  /search URLs without the scope still fall back to the product-card guard.
*/
(function () {
  var scope = document.documentElement.getAttribute('data-search-scope') || '';

  window.withBrandSearchScope = function (term) {
    if (!scope || !term || !term.trim() || term.indexOf(scope) !== -1) return term;
    return term.trim() + ' ' + scope;
  };

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!scope || !(form instanceof HTMLFormElement)) return;
      var action = form.getAttribute('action') || '';
      if (!/\/search\/?$/.test(action.split('?')[0])) return;

      var input = form.querySelector('[name="q"]');
      if (!input || input.type === 'hidden' || !input.value.trim()) return;

      var scoped = window.withBrandSearchScope(input.value);
      if (scoped === input.value) return;

      var hidden = form.querySelector('input[data-brand-scoped-q]');
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.setAttribute('data-brand-scoped-q', '');
        form.appendChild(hidden);
      }
      hidden.name = 'q';
      hidden.value = scoped;
      input.setAttribute('data-brand-scope-name', 'q');
      input.removeAttribute('name');
    },
    true
  );

  // Back/forward cache: put the visible field's name back so the form works again.
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-brand-scope-name]').forEach(function (input) {
      input.setAttribute('name', input.getAttribute('data-brand-scope-name'));
      input.removeAttribute('data-brand-scope-name');
    });
    document.querySelectorAll('input[data-brand-scoped-q]').forEach(function (hidden) {
      hidden.remove();
    });
  });
})();
